import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Paper, Typography, Container } from '@mui/material';
const ProtectionDonnees = () => {
    const theme = useTheme();
    return (
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>
            <Paper elevation={3} style={{
                padding: '20px',
                Color: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
            }}>
                <Typography variant="h4" gutterBottom>
                    Protection des Données Personnelles
                </Typography>
                <Typography variant="body1" paragraph>
                    Conformément à la loi Informatique et Libertés n°78-17 du 6 janvier 1978 modifiée et au Règlement
                    Général sur la Protection des Données à caractère personnel (ci-après « RGPD ») n° 2016/679/UE du
                    27 avril 2016, UNIPREVOYANCE, en qualité de responsable de traitement, garantit l’intégrité et la
                    sécurité des données personnelles des Utilisateurs de l’espace personnel : Mon unip (ci-après
                    dénommé le Site) et des services associés.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur, personne physique, est informé que les informations qu’il communique par le biais du
                    Site, dont les bases légales des traitements associés sont soit l’exécution de mesures
                    précontractuelles
                    ou contractuelles, soit l’intérêt légitime poursuivi par UNIPREVOYANCE afin de pouvoir répondre à
                    vos demandes, ainsi que des obligations légales, sont destinées aux services habilités de
                    UNIPREVOYANCE, le cas échéant, les partenaires, sous-traitants et tiers autorisés, à des fins de
                    gestion des relations clients et prospects, de lutte contre le blanchiment des capitaux et le
                    financement
                    du terrorisme, de gestion des risques opérationnels dont la fraude à l’assurance.
                </Typography>
                <Typography variant="body1" paragraph>
                    Les données personnelles ainsi collectées et traitées par UNIPREVOYANCE sont conservées pendant
                    les durées nécessaires dans le respect des obligations légales.
                </Typography>
                <Typography variant="body1" paragraph>
                    Pendant la consultation du Site et l’accès aux services en ligne, l’Utilisateur peut être sollicité
                    pour
                    communiquer volontairement certaines données personnelles (nom, prénom, courriel, email, numéro
                    de téléphone, identifiants, ...). Les formulaires de collecte présents sur le Site précisent
                    notamment le
                    responsable de traitement, la finalité, les destinataires, la durée de conservation et le caractère
                    obligatoire ou facultatif des données demandées.
                </Typography>
                <Typography variant="body1" paragraph>
                    Les données personnelles collectées et traitées sur le Site sont protégées par des mesures
                    techniques et
                    organisationnelles appropriées afin de garantir un niveau de sécurité adapté au risque.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur du Site est informé qu’il dispose d’un droit d’accès, de rectification, de
                    suppression, de
                    limitation, de portabilité (lorsqu’il s’applique) et d’opposition sur les données le concernant.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur peut exercer ces droits en s’adressant au service DPO d’UNIPREVOYANCE à l’adresse
                    électronique dpo@uniprevoyance.fr ou postale UNIPREVOYANCE 38-42 Rue Cuvier, CS 80 002,
                    93102 Montreuil Cedex.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur dispose également d’un droit de définir des directives relatives au sort de ses
                    données
                    personnelles après son décès.
                </Typography>
                <Typography variant="body1" paragraph>
                    En l’absence de directives ou de mention contraire dans ces directives, les héritiers de
                    l’Utilisateur
                    pourront – après son décès et en produisant un certificat de décès – exercer lesdits droits sur ses
                    données personnelles.
                </Typography>
                <Typography variant="body1" paragraph>
                    Les héritiers peuvent exercer ces droits en écrivant et en fournissant une copie de la pièce
                    d’identité et
                    du certificat de décès au DPO d’UNIPREVOYANCE conformément aux modalités précisées ci-dessus.
                </Typography>
                <Typography variant="body1" paragraph>
                    L’Utilisateur dispose également du droit d’introduire une réclamation auprès de la CNIL.
                </Typography>
                <Typography variant="body1" paragraph>
                    Les Utilisateurs du Site sont tenus de respecter les dispositions de la loi Informatique et Libertés
                    et du
                    RGPD, notamment en s’abstenant de toute collecte ou utilisation détournée des données à caractère
                    personnel auxquelles ils accèdent.
                </Typography>
                <a href="https://www.uniprevoyance.fr/download/rgpd-politique-externe-de-protection-des-donnees-personnelles/"
                   target={"_blank"}>Politique externe de protection des données personnelles – RGPD</a>
            </Paper>
        </Container>
    );
};

export default ProtectionDonnees;
